package co.maytes.standupbot.dashboard.features.newstandup

import co.maytes.standupbot.dashboard.features.standups.ScheduleSpec
import com.kttipay.mvi.api.MVIAction
import com.kttipay.mvi.api.MVIIntent
import com.kttipay.mvi.api.MVIState

object NewStandupContract {
    data class State(
        val workspaceId: String = "",
        val name: String = "",
        val channelId: String = "",
        val selectedSlackUserIds: Set<String> = emptySet(),
        val schedule: ScheduleSpec = ScheduleSpec.default("UTC"),
        val selectedTemplateId: String? = null,
        val pickerOpen: Boolean = false,
        val creating: Boolean = false,
    ) : MVIState {
        val canSubmit: Boolean
            get() = name.isNotBlank() &&
                channelId.isNotBlank() &&
                selectedSlackUserIds.isNotEmpty() &&
                schedule.firesAtLeastOnce &&
                !creating
    }

    sealed interface Intent : MVIIntent {
        data class Init(val workspaceId: String, val defaultTimezone: String) : Intent
        data class SetName(val value: String) : Intent
        data class SetChannelId(val value: String) : Intent
        data class SetMembers(val slackUserIds: Set<String>) : Intent
        data class SetSchedule(val value: ScheduleSpec) : Intent
        data class SetTemplateId(val value: String?) : Intent
        data object OpenPicker : Intent
        data object ClosePicker : Intent
        data class PickMembers(val adds: List<String>, val removes: List<String>) : Intent
        data class RemoveMember(val slackUserId: String) : Intent
        data object Submit : Intent
        data object Cancel : Intent
    }

    sealed interface Action : MVIAction {
        data class Navigate(val path: String) : Action
        data class Toast(val message: String, val error: Boolean = false) : Action
    }
}
